export default {
  admin: () => import("/home/dev/uogorod-build-local-fonts-20261103/layouts/admin.vue"),
  default: () => import("/home/dev/uogorod-build-local-fonts-20261103/layouts/default.vue"),
  feed: () => import("/home/dev/uogorod-build-local-fonts-20261103/layouts/feed.vue")
}